/**
 * **The one sentence that names the muted kinds** — `attention-queue` R12/R18, on every surface that
 * shows the queue: the Pulpit's tasks card, `/zadania`'s foot and the client's Przegląd.
 *
 * A surface presenting the queue must tell "nothing is waiting" from "kinds are muted, so hidden
 * work may exist", and it does so by NAMING the kinds — never a count, which R18 says is
 * deliberately not computed. Three surfaces used to build this sentence each on their own, and
 * `/zadania` had drifted to lower-case names while the other two wrote them as the catalog does.
 * The catalog's own title is the name here, as the Pulpit wrote it first.
 *
 * Pure: `t` arrives as a parameter. The link to `/zadania/rodzaje` after it is the surface's.
 */

import { attentionReasonTitleKey, type AttentionReason } from '~/entities/client';
import type { Translate } from '~/shared/lib/localeTranslate';

/** „Wyciszone: Trening w połowie, Brak aktywności." — or `null` when nothing is muted. */
export function mutedSentence(mutedReasons: readonly AttentionReason[], t: Translate): string | null {
  if (mutedReasons.length === 0) return null;
  const reasons = mutedReasons.map((reason) => t(attentionReasonTitleKey(reason))).join(', ');
  return t('web:home.muted.label', { reasons });
}
